<template>
  <a-modal
    v-model:open="open"
    :footer="null"
    centered
    :maskClosable="false"
    :keyboard="false"
    :width="460"
    class="hubspot_perm"
  >
    <div class="hubspot_perm__icons">
      <div class="app-icon">
        <beex-logo />
      </div>
      <div class="swap-arrows" aria-hidden="true">
        <ArrowSwipe />
      </div>
      <div class="app-icon">
        <HubspotIcon />
      </div>
    </div>

    <h2 class="hubspot_perm__title">
      Hubspot requiere que actualices los permisos con BeexCC.
    </h2>

    <p class="hubspot_perm__desc">
      Se han agregado nuevos permisos a tu integración de BeexCC con Hubspot. Actualiza para
      sincronizar los nuevos permisos, de lo contrario <strong>no estarán disponibles</strong>.
    </p>

    <div class="hubspot_perm__sub">Consideraciones:</div>
    <ul class="hubspot_perm__list">
      <li class="hubspot_perm__item">
        <LockOutlined />
        Para actualizar, se te pedirá iniciar sesión en Hubspot y conectar BeexCC con Hubspot nuevamente.
      </li>
      <li class="hubspot_perm__item">
        <TeamOutlined />
        Recuerda seleccionar la cuenta con rol desarrollador o no podrás realizar el proceso.
      </li>
    </ul>

    <a-button type="primary" block class="hubspot_perm__cta" @click="handleConfirm">
      Actualizar permisos
    </a-button>
  </a-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import BeexLogo from "@/app/shared/components/molecules/BeexLogo.vue";
import HubspotIcon from "@/app/integrations/components/icons/HubspotIcon.vue";
import ArrowSwipe from "@/app/shared/components/icons/ArrowSwipe.vue";
import { LockOutlined, TeamOutlined } from "@ant-design/icons-vue";
type Emits = {
  (e: 'confirm'): void
  (e: 'close'): void
}

const emit = defineEmits<Emits>()
const open = ref(true)

const handleConfirm = () => {
  emit('confirm')
}
</script>

<style lang="sass" scoped>
$muted: #6b7280
$text: #1f1f1f
$primary: #2f6bff
$primary-hover: #2558d6
$border: #e5e7eb

.hubspot_perm :deep(.ant-modal-content)
  border-radius: 16px
  padding: 24px 

.hubspot_perm :deep(.ant-modal-close)
  top: 10px
  right: 10px

.hubspot_perm__icons
  display: flex
  align-items: center
  justify-content: center
  margin-top: 4px
  margin-bottom: 12px
  .app-icon
    width: 64px
    height: 64px
    border-radius: 14px
    background: #ffffff
    border: 1px solid $border
    display: grid
    place-items: center
    svg
      width: 38px
      height: 38px
      color: #ff9f0a
      fill: none
      stroke: currentColor
      stroke-width: 2
      rect
        fill: #ffedd5
        stroke: #f59e0b
      circle
        fill: #ffedd5
      path
        stroke: #f59e0b
  .swap-arrows
    width: 44px
    height: 44px
    display: grid
    place-items: center
    color: #94a3b8
    svg
      width: 40px
      height: 24px

.hubspot_perm__title
  font-weight: 600
  font-style: Semibold
  font-size: 20px
  leading-trim: NONE
  line-height: 28px
  letter-spacing: 0%
  text-align: center


.hubspot_perm__desc
  font-weight: 400
  font-style: Regular
  font-size: 14px
  leading-trim: NONE
  line-height: 22px
  letter-spacing: 0%
  text-align: center

  strong
    color: #111827
    font-weight: 600

.hubspot_perm__sub
  font-weight: 600
  font-style: Semibold
  font-size: 14px
  leading-trim: NONE
  line-height: 22px
  letter-spacing: 0%
  color: #262626E0

.hubspot_perm__list
  list-style: none
  padding: 0
  margin: 0 0 18px
  display: grid
  gap: 10px

.hubspot_perm__item
  font-weight: 400
  font-style: Regular
  font-size: 14px
  leading-trim: NONE
  line-height: 22px
  letter-spacing: 0%
  color: #000000A6
  .li-icon
    width: 28px
    height: 28px
    border-radius: 8px
    background: #f1f5f9
    display: grid
    place-items: center
    color: #475569
    svg
      width: 18px
      height: 18px
      fill: currentColor

.hubspot_perm__cta
  font-weight: 400
  font-style: Regular
  font-size: 14px
  leading-trim: NONE
  line-height: 22px
  letter-spacing: 0%

  &:hover
    background: $primary-hover !important

:global(.hubspot_perm.ant-modal .ant-modal-content)
  padding: 38px 36px 29px !important
</style>

